export default "assets/images/icons/sound-open-f200d719.svg";